export const CREATE_DEPOSIT_APP = "CREATE_DEPOSIT_APP";
